import React from "react";
import { useState } from "react";
import { Box, Typography, RadioGroup, Button } from "@mui/material";
import OverlayRadio from "../components/OverlayRadio";
import gagency from "../imgs/gagency_white.svg";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../imgs/bg.png";

function SelectPlace() {
  const [checked, setChecked] = useState("Alger");
  const navigate = useNavigate();

  return (
    <Box
      bgcolor="black"
      width="100%"
      sx={{
        height: { xs: "auto", md: "100vh" },
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box padding="40px 16px" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Box sx={{ marginBottom: "40px", textAlign: { xs: "left", sm: "center" }, maxWidth: 1000 }}>
          <Typography fontSize="32px" fontWeight="bold" fontFamily={"NeurialGrotesk-Medium"} color="black">
            Veuillez choisir l'endroit où vous souhaitez participer à l'événement Squid Game.
          </Typography>
        </Box>

        <Box>
          <RadioGroup sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: "20px", maxWidth: "100%" }} val="entrepreneur" onChange={(e) => setChecked(e.target.value)}>
            {/* <OverlayRadio
              onClick={() => {
                setChecked("Sablette2");
              }}
              val="Sablette2"
              check={checked}
              icon="Sablette2"
              title="Alger"
              subtitle="Sablette - (EXPO KIDS)"
              time="19 juillet 2025"
            /> */}
            <OverlayRadio
              onClick={() => {
                setChecked("Alger");
              }}
              val="Alger"
              check={checked}
              icon="Alger"
              title="Alger"
              subtitle="El Achour"
              time="25 Juillet 2026"
            />
            <OverlayRadio
              onClick={() => {
                setChecked("Zeralda");
              }}
              val="Zeralda"
              check={checked}
              icon="fermeB"
              title="Alger"
              subtitle="Zeralda"
              time=""
            />

            <OverlayRadio onClick={() => setChecked("Blida")} val="Blida" check={checked} icon="Blida" title="Blida" subtitle="Beni Tamou" />
            {/* <OverlayRadio onClick={() => setChecked("Bab-ezzouar")} time="02 janvier 2025" val="Bab-ezzouar" check={checked} icon="Babezzouar" title="Bab-ezzouar" subtitle="Centre commercial" /> */}
            {/* <OverlayRadio onClick={() => setChecked("Enssea")} time="04 février 2025" val="Enssea" check={checked} icon="Enssea" title="Enssea" subtitle="Kolea" /> */}
            <OverlayRadio onClick={() => setChecked("Oran")} val="Oran" check={checked} icon="Essania" title="Oran" subtitle="Centre Commercial ES-SENIA" />
          </RadioGroup>
          <Box display="flex" flexDirection="row-reverse">
            <Button sx={{ marginTop: "40px", fontSize: "18px" }} disabled={checked === true ? true : checked === false ? true : false} variant="primary" onClick={() => navigate(`/${checked}`)}>
              Passer à l’inscription
            </Button>
          </Box>
        </Box>
        <Box position="relative" sx={{ marginTop: "40px", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "16px" }}>
          <img style={{ objectFit: "cover", height: "100px", mixBlendMode: "inherit" }} src={gagency} alt="G-Agency" />
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Box sx={{ cursor: "pointer" }} onClick={() => (window.location.href = "mailto:contact@g-agency.dz")}>
              <Typography textAlign="center" fontFamily={"NeurialGrotesk-Regular"} fontSize={"14px"} color="white">
                contact@g-agency.dz
              </Typography>
            </Box>
            <Box sx={{ cursor: "pointer" }}>
              <Typography textAlign="center" fontFamily={"NeurialGrotesk-Regular"} fontSize={"14px"} color="white">
                +213 559 34 31 38
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SelectPlace;
